import { render, staticRenderFns } from "./SwitchView.vue?vue&type=template&id=1b4eb5ce&"
import script from "./SwitchView.vue?vue&type=script&lang=js&"
export * from "./SwitchView.vue?vue&type=script&lang=js&"
import style0 from "./SwitchView.vue?vue&type=style&index=0&id=1b4eb5ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports